import type { IconData } from '../../types';

export const data: IconData = {
  o: '<path d="M266-26q-34 0-57-23t-23-56v-750q0-33 23-56 24-24 57-24h426q34 0 57 23 23 24 23 57v137q18 6 30 21 13 16 13 34v73q0 20-13 36-12 16-30 21v428q0 33-23 56t-57 23H266Zm-1-79h428v-750H265v750Zm0 0v-750 750Zm214-604q14 0 24-9 9-10 9-24t-9-24q-10-9-24-9t-24 9q-9 10-9 24t9 24q10 9 24 9Z"/>',
  f: '<path d="M266-26q-34 0-57-23t-23-56v-750q0-33 23-56 24-24 57-24h426q34 0 57 23t23 57v137q18 6 30 21 13 16 13 35v72q0 20-13 36-12 16-30 21v428q0 33-23 56t-57 23H266Zm213-683q14 0 24-10 9-9 9-23t-9-24q-10-9-24-9t-24 9q-9 10-9 24t9 23q10 10 24 10Z"/>',
};

export default data;
